import { useState } from 'react';
import { useArticleComments, useAddArticleComment } from '@/queries/articles';
import { CommentItem } from './CommentItem';
import styles from './ArticleComments.module.scss';

interface ArticleCommentsProps {
  articleId: string;
}

export function ArticleComments({ articleId }: ArticleCommentsProps) {
  const [newComment, setNewComment] = useState('');
  const { data: comments, isLoading } = useArticleComments(articleId);
  const addComment = useAddArticleComment();

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!newComment.trim()) return;

    addComment.mutate(
      { articleId, content: newComment.trim() },
      {
        onSuccess: () => {
          setNewComment('');
        },
      }
    );
  };

  return (
    <div className={styles.comments}>
      <h3 className={styles.comments__title}>
        Comments {comments && `(${comments.length})`}
      </h3>

      <div className={styles.comments__list}>
        {isLoading ? (
          <p className={styles.comments__loading}>Loading comments...</p>
        ) : comments && comments.length > 0 ? (
          comments.map((comment) => (
            <CommentItem
              key={comment.id}
              comment={comment}
              articleId={articleId}
            />
          ))
        ) : (
          <p className={styles.comments__empty}>No comments yet. Be the first to comment!</p>
        )}
      </div>

      <form onSubmit={handleSubmit} className={styles.comments__form}>
        <textarea
          className={styles.comments__input}
          value={newComment}
          onChange={(e) => setNewComment(e.target.value)}
          placeholder="Write a comment..."
          rows={3}
        />
        <button
          type="submit"
          className={styles.comments__submit}
          disabled={!newComment.trim() || addComment.isPending}
        >
          {addComment.isPending ? 'Posting...' : 'Post Comment'}
        </button>
      </form>
    </div>
  );
}
